import { render, staticRenderFns } from "./AboutTab.vue?vue&type=template&id=892ba488&scoped=true"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"
import style0 from "./AboutTab.vue?vue&type=style&index=0&id=892ba488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ba488",
  null
  
)

export default component.exports